import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import CryptoJS from 'crypto-js';
import axios from 'axios';

// Configuración para roles
const ROLE_STORAGE_KEY = 'user_role';
// const CACHE_EXPIRATION_MS = 3 * 1000; // 30 segundos para pruebas
// const CACHE_EXPIRATION_MS = 30 * 60 * 1000; // 30 minutos para producción
const CACHE_EXPIRATION_MS = 24 * 60 * 60 * 1000; // 1 dia para producción
const SECRET_KEY = 's3cr3tK3y!@#2025'; // Clave secreta segura

function encrypt(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
}

function decrypt(data) {
  try {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error('Error al desencriptar los datos:', error);
    return null;
  }
}

export default createStore({
  state: {
    isLoggedIn: false,
    isFirstLoad: true,
    user: null,
    isAuthenticated: false,
    roleToken: '', // Default role token
    role: null, // Rol actual del usuario
    roleLoaded: false, // Indicador si el rol está cargado
    tokens: {
      clavePendiente: null,
      tokenFinal: null,
    },
  },
  mutations: {
    setSelectedCameraId(state, deviceId) {
      state.selectedCameraId = deviceId;
    },
    setRole(state, role) {
      state.role = role;
      state.roleLoaded = true;
    },
    setTokens(state, tokens) {
      state.tokens = tokens;
    },
    clearState(state) {
      state.tokens = {
        clavePendiente: null,
        tokenFinal: null,
      };
      state.isFirstLoad = true;
    },
    setLoginState(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setUser(state, userData) {
      state.user = userData;
      state.isAuthenticated = true;
      state.isLoggedIn = true;
      state.roleToken = userData.role; // Guardar el token del rol encriptado
    },
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.isLoggedIn = false;
      state.roleToken = ''; // Reset role token
      state.role = null; // Limpia el rol del usuario
      state.roleLoaded = false;
    },
    setRoleToken(state, roleToken) {
      state.roleToken = roleToken;
    },
    clearRole(state) {
      state.role = null;
      state.roleLoaded = false;
      state.roleToken = '';
    },
  },
  actions: {
    login({ commit }, user) {
      commit('setUser', user);
      commit('setLoginState', true);
    },
    logout({ commit }) {
      commit('clearUser');
      commit('setLoginState', false);
      localStorage.removeItem(ROLE_STORAGE_KEY);
    },
    async fetchRole({ commit, state }) {
      const cachedRole = localStorage.getItem(ROLE_STORAGE_KEY);
      if (cachedRole) {
        const { role, timestamp } = decrypt(cachedRole);
        if (role && Date.now() - timestamp < CACHE_EXPIRATION_MS) {
          commit('setRole', role);
          return;
        }
      }

      try {
        const response = await axios.post('/api/verify-role', {
          roleToken: state.roleToken,
          userToken: state.user?.token,
        });
        const { role, newRoleToken } = response.data;

        if (role && newRoleToken) {
          localStorage.setItem(
            ROLE_STORAGE_KEY,
            encrypt({ role, timestamp: Date.now() })
          );
          commit('setRole', role);
          commit('setRoleToken', newRoleToken); // Actualiza explícitamente el roleToken
          commit('setUser', { ...state.user, role: newRoleToken });
        } else {
          throw new Error('Rol o token inválido devuelto por el servidor');
        }
      } catch (error) {
        console.error('Error al verificar rol:', error);
        commit('clearRole');
        throw error;
      }
    },
    startRoleAutoRefresh({ dispatch, state }) {
      const refreshInterval = CACHE_EXPIRATION_MS;

      async function refreshRole() {
        try {
          await dispatch('fetchRole');
        } catch (error) {
          console.error('Error al actualizar rol automáticamente:', error);
        }
      }

      setInterval(() => {
        if (state.roleToken && state.user?.token) {
          refreshRole();
        }
      }, refreshInterval);
    },
  },
  plugins: [
    createPersistedState({
      paths: [
        'tokens',
        'isLoggedIn',
        'user',
        'isAuthenticated',
        'roleToken',
        'role',    
        'roleLoaded',
      ],
    }),
  ],
});
